import User from "@mapmycustomers/shared/types/User";

const formatUserTeamsById = (users?: User[]): Record<User["id"], string> =>
  users?.reduce(
    (result, user) => ({ ...result, [user.id]: user.teams.map(({ name }) => name).join(", ") }),
    {}
  ) ?? {};

export default formatUserTeamsById;
